/**
 * Profile constants
 *
 */
export const DEFAULT_PROFILE_PIC = 'default';
export const DEFAULT_LOCALE = CBS.Registry.region.property?.toLowerCase() ?? '';
export const SECTION_HEADER_CREATE_PIN = 'Create a 4-digit PIN for kids profiles';
export const SECTION_SUB_HEADER_CREATE_PIN = 'Your PIN will be required to switch profiles. You can manage this in your account settings.';
export const DISCLAIMER_URL = 'https://help.paramountplus.com/s/article/PD-How-do-I-set-parental-controls-for-Paramount';

export const KIDS = 'KIDS';
export const ADULT = 'ADULT';
export const YOUNGER_KIDS = 'YOUNGER_KIDS';
export const ALL = "ALL";

export const ALLOWED_PROFILE_TYPES = [
    KIDS,
    ADULT,
    YOUNGER_KIDS
];
